import React from "react";
import { List } from "../modules/BillerInvoiceSearch";

export function BillerInvoicesListPage() {
  return <List />;
}
